import * as t from './types'

export const getMessages = (state: t.State) => state.messages
